import { render, staticRenderFns } from "./m-num.vue?vue&type=template&id=4c8bda73&scoped=true&"
import script from "./m-num.vue?vue&type=script&lang=js&"
export * from "./m-num.vue?vue&type=script&lang=js&"
import style0 from "./m-num.vue?vue&type=style&index=0&id=4c8bda73&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8bda73",
  null
  
)

export default component.exports